import { render } from "./PriceItem.vue?vue&type=template&id=f3fe038c&scoped=true&lang=pug"
import script from "./PriceItem.vue?vue&type=script&lang=js"
export * from "./PriceItem.vue?vue&type=script&lang=js"

import "./PriceItem.vue?vue&type=style&index=0&id=f3fe038c&lang=scss&scoped=true"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3fe038c"]])

export default __exports__